import React from 'react';
import {
  Platform,
  Switch as RNSwitch,
  SwitchProps,
} from 'react-native';

import { useColors } from '@hooks';

export interface ISwitchProps extends SwitchProps {
  value?: boolean;
  onValueChange?: (value: boolean) => void;
}

export function Switch({
  value = false,
  onValueChange,
  ...props
}: ISwitchProps) {
  const colors = useColors();

  function toggleStatus() {
    if (onValueChange) {
      onValueChange(!value);
    }
  }

  return (
    <RNSwitch
      {...props}
      {...Platform.select({
        web: {
          activeThumbColor: colors.$background0,
        },
      })}
      trackColor={{
        false: colors.$background50,
        true: colors.$primary300,
      }}
      thumbColor={colors.$background0}
      ios_backgroundColor={colors.$background50}
      value={value}
      onValueChange={toggleStatus}
    />
  );
}
